module.exports = __webpack_public_path__ + "r-v3/img/icon-bar-graph_off.c075751e.svg";